import { HttpContextToken } from '@angular/common/http';

export type HttpLoaderMode = 'auto' | 'blocking' | 'background' | 'none';

export const HTTP_LOADER_MODE = new HttpContextToken<HttpLoaderMode>(() => 'auto');
